/* ONDA — interactions: nav, reveal, accordions, carousels, configurateur, panier AJAX */
(function () {
  'use strict';
  if (window.__ondaInit) return;
  window.__ondaInit = true;

  var euro = function (n) { return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + '€'; };
  var euroC = function (cents) { return euro(cents / 100); };

  document.addEventListener('DOMContentLoaded', function () {

    /* ---------- Nav ---------- */
    var nav = document.querySelector('[data-onda-nav]');
    if (nav) {
      var isHome = nav.getAttribute('data-home') === 'true';
      if (isHome) {
        var onScroll = function () {
          nav.classList.toggle('is-solid', window.scrollY > 40);
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
      }
      var burger = nav.querySelector('[data-burger]');
      var mobile = nav.querySelector('[data-mobile-menu]');
      if (burger && mobile) {
        burger.addEventListener('click', function () {
          mobile.hidden = !mobile.hidden;
        });
        mobile.querySelectorAll('a').forEach(function (a) {
          a.addEventListener('click', function () { mobile.hidden = true; });
        });
      }
    }

    /* ---------- Reveal on scroll ---------- */
    var els = document.querySelectorAll('.reveal:not(.in)');
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.95 && r.bottom > -40) { el.style.transition = 'none'; el.classList.add('in'); }
      else io.observe(el);
    });

    /* ---------- Accordions (FAQ + PDP) ---------- */
    document.querySelectorAll('[data-acc-group]').forEach(function (group) {
      var items = group.querySelectorAll('[data-acc]');
      items.forEach(function (item) {
        var q = item.querySelector('[data-acc-q]');
        if (!q) return;
        q.addEventListener('click', function () {
          var wasOpen = item.classList.contains('open');
          items.forEach(function (i) { i.classList.remove('open'); });
          if (!wasOpen) item.classList.add('open');
        });
      });
    });

    /* ---------- Testimonials carousel ---------- */
    document.querySelectorAll('[data-avis]').forEach(function (root) {
      var track = root.querySelector('[data-avis-track]');
      var cards = track ? track.children : [];
      if (!track || !cards.length) return;
      var i = 0, n = cards.length;
      var update = function () {
        var w = cards[0].getBoundingClientRect().width + 22;
        track.style.transform = 'translateX(' + (-i * w) + 'px)';
      };
      var prev = root.querySelector('[data-avis-prev]');
      var next = root.querySelector('[data-avis-next]');
      if (prev) prev.addEventListener('click', function () { i = (i - 1 + n) % n; update(); });
      if (next) next.addEventListener('click', function () { i = (i + 1) % n; update(); });
      window.addEventListener('resize', update);
    });

    /* ---------- PDP gallery ---------- */
    document.querySelectorAll('[data-gallery]').forEach(function (root) {
      var frames = root.querySelectorAll('[data-frame]');
      var thumbs = root.querySelectorAll('[data-thumb]');
      var active = 0, n = frames.length;
      var show = function (idx) {
        active = (idx + n) % n;
        frames.forEach(function (f, j) { f.style.display = j === active ? 'block' : 'none'; });
        thumbs.forEach(function (t, j) { t.classList.toggle('sel', j === active); });
      };
      thumbs.forEach(function (t, j) { t.addEventListener('click', function () { show(j); }); });
      var l = root.querySelector('[data-gal-prev]');
      var r = root.querySelector('[data-gal-next]');
      if (l) l.addEventListener('click', function () { show(active - 1); });
      if (r) r.addEventListener('click', function () { show(active + 1); });
      show(0);
    });

    /* ---------- Cart (AJAX Shopify) ---------- */
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-overlay]');
    var badges = document.querySelectorAll('[data-cart-count]');

    var renderCart = function (cart) {
      badges.forEach(function (b) {
        b.textContent = cart.item_count;
        b.hidden = cart.item_count === 0;
      });
      if (!drawer) return;
      var body = drawer.querySelector('[data-cart-lines]');
      var foot = drawer.querySelector('[data-cart-foot]');
      if (!body) return;
      if (!cart.items.length) {
        body.innerHTML = '<div class="o-cart__empty"><span class="ic"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5h2l1.5 11h10L20 8H6"/><circle cx="9" cy="20" r="1.3"/><circle cx="17" cy="20" r="1.3"/></svg></span><p>Votre panier est vide.</p></div>';
        if (foot) foot.style.display = 'none';
        return;
      }
      var html = '';
      cart.items.forEach(function (it, idx) {
        var plan = it.variant_title || '';
        if (it.properties) {
          Object.keys(it.properties).forEach(function (k) {
            if (k.charAt(0) !== '_' && it.properties[k]) plan += ' · ' + it.properties[k];
          });
        }
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') : '';
        html += '<div class="o-cart__line" data-line="' + (idx + 1) + '">' +
          (img ? '<img src="' + img + '" alt="">' : '') +
          '<div class="o-cart__line-main">' +
          '<div class="o-cart__line-top"><strong>' + it.product_title + '</strong>' +
          '<button class="o-cart__rm" data-rm aria-label="Retirer"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M7 7l10 10M17 7L7 17"/></svg></button></div>' +
          '<div class="o-cart__plan">' + plan + '</div>' +
          '<div class="o-cart__line-bot">' +
          '<div class="o-cart__qty"><button data-dec aria-label="Moins"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg></button>' +
          '<span>' + it.quantity + '</span>' +
          '<button data-inc aria-label="Plus"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button></div>' +
          '<span class="o-cart__lp">' + euroC(it.final_line_price) + '</span>' +
          '</div></div></div>';
      });
      body.innerHTML = html;
      if (foot) {
        foot.style.display = 'block';
        var tot = foot.querySelector('[data-cart-total]');
        if (tot) tot.textContent = euroC(cart.total_price);
      }
      body.querySelectorAll('.o-cart__line').forEach(function (line) {
        var ln = parseInt(line.getAttribute('data-line'), 10);
        var qtyEl = line.querySelector('.o-cart__qty span');
        var change = function (q) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: ln, quantity: q })
          }).then(function (r) { return r.json(); }).then(renderCart);
        };
        line.querySelector('[data-dec]').addEventListener('click', function () { change(parseInt(qtyEl.textContent, 10) - 1); });
        line.querySelector('[data-inc]').addEventListener('click', function () { change(parseInt(qtyEl.textContent, 10) + 1); });
        line.querySelector('[data-rm]').addEventListener('click', function () { change(0); });
      });
    };

    var refreshCart = function (open) {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        renderCart(c);
        if (open) openCart();
      });
    };
    var openCart = function () {
      if (drawer) { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); }
      if (overlay) overlay.classList.add('open');
    };
    var closeCart = function () {
      if (drawer) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
      if (overlay) overlay.classList.remove('open');
    };
    document.querySelectorAll('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function () { refreshCart(true); });
    });
    if (overlay) overlay.addEventListener('click', closeCart);
    if (drawer) {
      var cl = drawer.querySelector('[data-cart-close]');
      if (cl) cl.addEventListener('click', closeCart);
    }
    refreshCart(false);

    /* ---------- Configurateur ---------- */
    document.querySelectorAll('[data-config]').forEach(function (root) {
      var REF = parseFloat(root.getAttribute('data-ref')) || 34.90;
      var V = {
        once: { id: root.getAttribute('data-once-id'), unit: parseFloat(root.getAttribute('data-once-price')) },
        m1: { id: root.getAttribute('data-m1-id'), unit: parseFloat(root.getAttribute('data-m1-price')), sachets: 1, label: '1 mois' },
        m3: { id: root.getAttribute('data-m3-id'), unit: parseFloat(root.getAttribute('data-m3-price')), sachets: 3, label: '3 mois' }
      };
      var state = { dogs: 1, cadence: 'm3', mode: 'sub', added: false };

      var dogBtns = root.querySelectorAll('[data-dog]');
      var cads = root.querySelectorAll('[data-cad]');
      var cta = root.querySelector('[data-cta]');
      var ctaLbl = root.querySelector('[data-cta-label]');
      var ctaRef = root.querySelector('[data-cta-ref]');
      var ctaTot = root.querySelector('[data-cta-total]');
      var toggle = root.querySelector('[data-mode-toggle]');
      var shipLeft = root.querySelector('[data-ship-left]');

      var deliveryDate = (function () {
        var d = new Date(Date.now() + 3 * 864e5);
        var s = d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
        return s.charAt(0).toUpperCase() + s.slice(1);
      })();

      var calc = function () {
        var cad = V[state.cadence];
        var sachets = state.mode === 'once' ? state.dogs : cad.sachets * state.dogs;
        var unitNow = state.mode === 'once' ? V.once.unit : cad.unit;
        return { sachets: sachets, unitNow: unitNow, nowTotal: unitNow * sachets, refTotal: REF * sachets, cad: cad };
      };

      var render = function () {
        var c = calc();
        root.classList.toggle('is-once', state.mode === 'once');
        dogBtns.forEach(function (b) {
          var d = parseInt(b.getAttribute('data-dog'), 10);
          b.classList.toggle('sel', state.dogs === d);
          var save = b.querySelector('.save');
          if (save) {
            if (d > 1 && state.mode === 'sub') {
              var cad = V[state.cadence];
              save.textContent = '−' + euro((REF - cad.unit) * cad.sachets * d);
              save.style.display = 'inline-block';
            } else save.style.display = 'none';
          }
        });
        cads.forEach(function (cd) {
          var id = cd.getAttribute('data-cad');
          cd.classList.toggle('sel', state.mode === 'sub' && state.cadence === id);
        });
        if (shipLeft) {
          shipLeft.innerHTML = state.mode === 'once'
            ? '<span class="dot"></span> Expédié sous 48 h'
            : '<span class="dot"></span> Prochaine livraison : <strong>&nbsp;' + deliveryDate + '</strong>';
        }
        if (!state.added) {
          if (ctaLbl) ctaLbl.textContent = 'Commencer maintenant';
          if (ctaRef) {
            ctaRef.textContent = euro(c.refTotal);
            ctaRef.style.display = state.mode === 'once' ? 'none' : 'inline';
          }
          if (ctaTot) { ctaTot.textContent = euro(c.nowTotal); ctaTot.style.display = 'inline'; }
        }
        if (toggle) {
          toggle.textContent = state.mode === 'once'
            ? 'Revenir à l’abonnement (jusqu’à −30 %)'
            : 'Acheter un sachet en achat unique ' + euro(V.once.unit);
        }
      };

      dogBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          state.dogs = parseInt(b.getAttribute('data-dog'), 10); render();
        });
      });
      cads.forEach(function (cd) {
        var btn = cd.querySelector('[data-cad-btn]');
        if (btn) btn.addEventListener('click', function () {
          state.cadence = cd.getAttribute('data-cad'); state.mode = 'sub'; render();
        });
      });
      if (toggle) toggle.addEventListener('click', function () {
        state.mode = state.mode === 'once' ? 'sub' : 'once'; render();
      });

      if (cta) cta.addEventListener('click', function () {
        var c = calc();
        var variantId = state.mode === 'once' ? V.once.id : c.cad.id;
        var planLabel = state.mode === 'once'
          ? 'Achat unique · ' + state.dogs + ' chien' + (state.dogs > 1 ? 's' : '')
          : 'Abonnement ' + c.cad.label + ' · ' + state.dogs + ' chien' + (state.dogs > 1 ? 's' : '');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(variantId, 10),
            quantity: c.sachets,
            properties: { 'Chiens': String(state.dogs), 'Plan': planLabel }
          })
        }).then(function (r) { return r.json(); }).then(function () {
          state.added = true;
          if (ctaLbl) ctaLbl.innerHTML = 'Ajouté au panier ✓';
          if (ctaRef) ctaRef.style.display = 'none';
          if (ctaTot) ctaTot.style.display = 'none';
          refreshCart(true);
          setTimeout(function () { state.added = false; render(); }, 1800);
        });
      });

      render();
    });

    /* ---------- Footer newsletter ---------- */
    document.querySelectorAll('[data-nl]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type="email"]');
        if (!input || input.value.indexOf('@') === -1) return;
        var ok = form.querySelector('[data-nl-ok]');
        var ic = form.querySelector('[data-nl-ic]');
        if (ok) ok.hidden = false;
        if (ic) ic.innerHTML = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 6.5"/></svg>';
      });
    });
  });
})();
